import { PaginatedRequest } from '../requestModels/paginatedRequest';
import { httpGet, httpGet_New, httpGetFile, httpPost, httpPost_New } from './api.service';
import { Device } from '../types/Device';
import { PaginatedResult } from '../types/PaginatedResult';
import { Result } from '../types/Result';
import { EmptyResult } from '../types/EmptyResult';
import { DeviceEnriched } from '../types/DeviceEnriched';
import { UnpairRequest } from '../requestModels/unpairRequest';
import { PairingRequest } from '../requestModels/pairingRequest';
import { SuperSentinelStatus } from '../types/SuperSentinel';

// TODO: just changed getDevices, getDevicebyObjectId and getDevice
// to use the new request type. Double check all uses!

// TODO: Secondly, make useDeviceDetails use DeviceEnriched instead of straight device
// and then make DeviceStage use the same.

export const getDevices = async (model: PaginatedRequest): Promise<PaginatedResult<DeviceEnriched>> =>
  await httpGet_New<PaginatedResult<DeviceEnriched>>('api/device', model);

export const getDevicebyObjectId = async (id: string): Promise<PaginatedResult<DeviceEnriched>> =>
  await httpGet_New<PaginatedResult<DeviceEnriched>>('api/device', { filters: [{ id: id }] });

export const getDeviceBySerialNumber = async (serialNumber: string): Promise<PaginatedResult<DeviceEnriched>> =>
  await httpGet_New<PaginatedResult<DeviceEnriched>>('api/device', { filters: [{ currentPairedEquipmentSerialNumber: serialNumber }] });

export const getDevice = async (id: string): Promise<DeviceEnriched> => await httpGet_New<DeviceEnriched>('api/device/' + id);

const toFilterPayload = (filters?: any[]) =>
  (filters ?? []).map((f) => {
    const { filterType, and, ...fieldEntry } = f;
    const [fieldName, fieldValue] = Object.entries(fieldEntry)[0];
    return { fieldName, filterType, fieldValue };
  });

const toSortPayload = (sortBy?: any[]) =>
  (sortBy ?? []).map((s) => {
    const [key, value] = Object.entries(s)[0];
    return { key, value };
  });

export const exportEntities = (entityType: string, request: PaginatedRequest): Promise<void> => {
  const { filters, sortBy, ...rest } = request;

  const payload = {
    entityType,
    filter: JSON.stringify({
      filters: toFilterPayload(filters),
      sort: toSortPayload(sortBy),
    }),
    ...rest,
  };
  return httpGetFile(`api/export`, payload);
};

export const exportDevices = (request: PaginatedRequest): Promise<void> => exportEntities('Device', request);

export const pairDevice = async (pairingSessionId: string | undefined, payload: PairingRequest): Promise<EmptyResult> => {
  if (pairingSessionId) return await httpPost<EmptyResult>(`api/pairing/${pairingSessionId}/pair`, payload);
  else return await httpPost<EmptyResult>(`api/pairing/pair`, payload);
};

export const unpairDevice = async (pairingSessionId: string | undefined, id: string, payload: UnpairRequest): Promise<EmptyResult> => {
  if (pairingSessionId) return await httpPost<EmptyResult>(`api/pairing/${pairingSessionId}/unpair/device/${id}`, payload);
  else return await httpPost<EmptyResult>(`api/pairing/unpair/device/${id}`, payload);
};

export const searchDeviceIds = async (searchValue: string): Promise<Result<Device>> =>
  await httpGet<Result<Device>>(`api/device/deviceid/search/${searchValue}`);

export const updateIsDeviceHealthyOverride = async (id: string, override: boolean | null) =>
  await httpPost_New<DeviceEnriched>(`api/device/${id}/is-healthy-override`, { isDeviceHealthyOverride: override });

export const updateDeviceLabels = async (request: any): Promise<void> => {
  return await httpPost(`api/device/label`, request);
};

// SuperSentinel
export interface SuperSentinelActivateRequest {
  /** ISO 8601 datetime string, e.g. "2026-03-03T10:09:00.000000Z" */
  enableUntil: string;
}

export const getSuperSentinelStatus = async (deviceId: string): Promise<SuperSentinelStatus> =>
  await httpGet_New<SuperSentinelStatus>(`api/device/${deviceId}/supersentinel/status`);

export const activateSuperSentinel = async (deviceId: string, payload: SuperSentinelActivateRequest): Promise<EmptyResult> =>
  await httpPost<EmptyResult>(`api/device/${deviceId}/supersentinel/activate`, payload);

export const deactivateSuperSentinel = async (deviceId: string): Promise<EmptyResult> =>
  await httpPost<EmptyResult>(`api/device/${deviceId}/supersentinel/deactivate`, {});
